import React from "react";
import { useTranslation } from "react-i18next";
import { BaseComponentProps } from "./types";

interface Props extends BaseComponentProps {
    hitCount?: number;
}

export const RecipientComponent = React.memo(({ invoice, hitCount }: Props) => {
    const { t } = useTranslation("invoice");
    return (
        <div className="tw-flex tw-flex-col tw-gap-1 tw-px-2 tw-overflow-hidden">
            <div className="tw-flex tw-items-center tw-gap-2">
                <span className="tw-font-bold tw-line-clamp-1">{invoice.line0}</span>
                {(hitCount ?? 0) > 0 && !invoice.bank_transactions?.length && (
                    <span className="tw-shrink-0 tw-rounded-md tw-bg-amber-100 tw-px-1.5 tw-py-0.5 tw-text-xs tw-font-medium tw-text-amber-700">
                        {t("invoiceList.recipient.hits", { count: hitCount ?? 0 })}
                    </span>
                )}
            </div>
            <span className="!tw-text-accents-7 tw-text-xs">{invoice.email}</span>
            <span className="!tw-text-accents-7 tw-text-xs">
                {invoice.line1}
            </span>
            {invoice.line2 && (
                <span className="!tw-text-accents-7 tw-text-xs">
                    {invoice.line2}
                </span>
            )}
            <span className="!tw-text-accents-7 tw-text-xs">
                {invoice.postcode} {invoice.city}
            </span>
        </div>
    );
});

RecipientComponent.displayName = "RecipientComponent";
